<template>
  <div class="fee-container">
    <!-- 顶部导航栏 -->
    <div class="fee-header">
      <h1 class="fee-title">利群数字资源平台文章发布收费标准</h1>
      <div class="fee-version">版本：V1.0 | 更新时间：2024-05-20</div>
    </div>
    <!-- 收费标准内容区域（滚动显示） -->
    <div class="fee-content">
      <h3>1 收费项目</h3>
      <p>第三方用户在平台发布单篇文章所产生的服务费用。</p>

      <h3>2 收费标准</h3>
      <p>每篇文章发布费用为1元人民币。</p>

      <h3>3 支付方式</h3>
      <p>用户发布文章前，需通过平台支持的在线支付方式（如微信支付、支付宝等）足额支付对应费用，支付成功后平台将进行后台审核，审核通过后方可发布。</p>

      <h3>4 费用说明</h3>
      <p>4.1 费用仅包含文章发布服务费用，不包含文章创作、修改、推广等其他服务费用。</p>
      <p>4.2 文章因不符合平台规范被拒绝发布的，平台将全额退还该篇文章的发布费用。</p>
      <p>4.3 文章发布后，因用户自身原因删除或修改后重新发布的，需重新支付发布费用。</p>

      <p class="fee-note">注：本文件内容最终解释权归利群集团股份有限公司所有，平台有权根据业务调整对内容进行修订，修订后将通过平台公告通知用户。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeeStandard",
  mounted() {
    // 滚动到页面顶部
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.fee-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}
.fee-header {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}
.fee-title {
  font-size: 20px;
  color: #333;
  text-align: center;
  margin: 10px 0;
  font-weight: 600;
}
.fee-version {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.fee-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.fee-content h3 {
  font-size: 16px;
  color: #222;
  margin: 20px 0 10px;
  font-weight: 600;
}
.fee-content p {
  margin: 8px 0;
  text-indent: 2em;
}
.fee-note {
  color: #666;
  font-size: 13px;
  margin-top: 30px;
  text-indent: 0 !important;
}
/* 滚动条样式优化 */
.fee-content::-webkit-scrollbar {
  width: 6px;
}
.fee-content::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
/* 移动端适配 */
@media screen and (max-width: 768px) {
  .fee-content {
    padding: 20px;
    max-height: calc(100vh - 180px);
  }
  .fee-title {
    font-size: 18px;
  }
}
</style>